import React from "react"

import { BillDetailReadonlyFields } from "@/components/bills/bill-detail-readonly-fields"
import { AdminEntityLink } from "@/modules/admin/components/admin-entity-link"
import { adminEntityFieldsMaxWidthSx } from "@/modules/admin/utils/admin-entity-fields-max-width-sx"
import type { Bill } from "@/services/core-api/types"
import { useUrl } from "@/utils/url"
import { getDisplayValue } from "@/utils/value"

import { Stack } from "@mui/material"

interface BillReadonlyFieldsProps {
  bill: Bill
  meterCode?: string | null
  meterId?: string | null
  siteId?: string | null
  siteName?: string | null
}

export const BillReadonlyFields: React.FC<BillReadonlyFieldsProps> = ({
  bill,
  meterCode,
  meterId,
  siteId,
  siteName,
}) => {
  const { adminMeterPath, adminSitePath } = useUrl()
  const displaySiteName = getDisplayValue(siteName)
  const displayMeterCode = getDisplayValue(meterCode)
  const siteTo = siteId && siteName?.trim() ? adminSitePath(siteId) : undefined
  const meterTo =
    meterId && meterCode?.trim() ? adminMeterPath(meterId) : undefined

  return (
    <Stack sx={{ ...adminEntityFieldsMaxWidthSx, gap: 2 }}>
      <BillDetailReadonlyFields
        bill={bill}
        meterValue={<AdminEntityLink label={displayMeterCode} to={meterTo} />}
        showLocked
        showSourceType
        siteValue={<AdminEntityLink label={displaySiteName} to={siteTo} />}
      />
    </Stack>
  )
}
